module.exports = __webpack_public_path__ + "static/banner-home-92d1ee916ff59202297af1eaa8ba34aa.jpg";